import React, { useEffect, useRef, useState } from 'react'
import '../views/ImageCarroussel.css'

const ImageCarousel = ({
  images = [],
  interval = 4000,
  height = '420px',
  showControls = true,
  showIndicators = true,
}) => {
  const [index, setIndex] = useState(0)
  const timerRef = useRef(null)
  const mountedRef = useRef(false)

  useEffect(() => {
    // start autoplay once component mounted
    if (!images || images.length === 0) return
    start()
    mountedRef.current = true
    return stop
  }, [images])

  useEffect(() => {
    // cleanup on unmount
    return () => stop()
  }, [])

  const start = () => {
    stop()
    timerRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % images.length)
    }, interval)
  }

  const stop = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current)
      timerRef.current = null
    }
  }

  const goTo = (i) => {
    setIndex(((i % images.length) + images.length) % images.length)
    // restart timer so user sees next autoplay interval
    if (mountedRef.current) {
      start()
    }
  }

  return (
    <div
      className="carousel-root"
      onMouseEnter={stop}
      onMouseLeave={start}
      style={{ '--carousel-height': height }}
    >
      <div className="carousel-viewport" aria-live="off">
        {images.map((img, i) => (
          <div
            className={`carousel-slide ${i === index ? 'active' : ''}`}
            key={i}
            aria-hidden={i !== index}
          >
            <img
              src={img.src}
              alt={img.alt || `Slide ${i + 1}`}
              className="carousel-image"
              loading="lazy"
              srcSet={img.srcSet || undefined}
              sizes={img.sizes || undefined}
            />
          </div>
        ))}
      </div>

      {showControls && (
        <div className="carousel-controls">
          <button
            className="carousel-btn carousel-prev"
            onClick={() => goTo(index - 1)}
            aria-label="Précédent"
          >
            ‹
          </button>
          <button
            className="carousel-btn carousel-next"
            onClick={() => goTo(index + 1)}
            aria-label="Suivant"
          >
            ›
          </button>
        </div>
      )}

      {showIndicators && (
        <div className="carousel-indicators" role="tablist">
          {images.map((_, i) => (
            <button
              key={i}
              className={`carousel-indicator ${i === index ? 'active' : ''}`}
              onClick={() => goTo(i)}
              aria-label={`Voir l'image ${i + 1}`}
              aria-selected={i === index}
              role="tab"
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ImageCarousel